import { useState } from 'react';

export const useInput = (
  initialValue: string,
  type = 'text'
): readonly [
  string,
  {
    value: string;
    type: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  },
  React.Dispatch<React.SetStateAction<string>>
] => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return [value, { value, type, onChange: handleChange }, setValue] as const;
};
